import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class FileTypeModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (FileTypeModel._instance == null) FileTypeModel._instance = new FileTypeModel(authManager);
        return FileTypeModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'core/file-types', 'core/file-types/codelist');

        this.entityName = 'core.FileType';
        this.privileges = {
            create: [["#admin"]],
            read: [["#admin"]],
            update: [["#admin"]],
            delete: [["#admin"]],
        };

        this.label = 'File Type';
        this.setLabel = 'File Types';

        this.browser = {
            name: 'default-core-filetype-browser',
            moduleName: 'default-core-filetype-browser',
            moduleTitle: 'File Types',
            moduleStateSlotName: 'default-core-filetype-browser',
        };

        this.editor = {
            name: 'default-core-filetype-editor',
            moduleName: 'default-core-filetype-editor',
            moduleTitle: 'File Type',
            moduleStateSlotName: 'default-core-filetype-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'code',
                type: 'string',
                persistent: true,
                label: 'Code',
                required: true,
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'name',
                type: 'string',
                persistent: true,
                label: 'Name',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'description',
                type: 'text',
                persistent: true,
                label: 'Description',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'extension',
                type: 'string',
                persistent: true,
                label: 'Extension',
            },
            {
                name: 'altExtensions',
                type: 'text',
                persistent: true,
                label: 'Alternative Extensions',
            },
            {
                name: 'mimeType',
                type: 'string',
                persistent: true,
                label: 'MIME Type',
            },
            {
                name: 'altMimeTypes',
                type: 'text',
                persistent: true,
                label: 'Alternative MIME Types',
            },
            {
                name: 'icon',
                type: 'string',
                persistent: true,
                label: 'Icon',
            },
            {
                name: 'isDisabled',
                type: 'bool',
                persistent: true,
                label: 'Is Disabled',
                inEditor: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'notes',
                type: 'text',
                persistent: true,
                label: 'Notes',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'displayPosition',
                type: 'int',
                persistent: true,
                label: 'Display Position',
                inEditor: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayLabel',
                type: 'string',
                persistent: false,
                label: 'Display Label',
                readOnly: true,
            },
            {
                name: 'displayDisabled',
                type: 'bool',
                persistent: false,
                label: 'Display Disabled',
                readOnly: true,
            },
        ];

    }

}
